<template>
    <div :style="`min-width:${barChartTotal.chartData.labels.length * 8}px;max-width:100%;`">
        <bar-chart :height="height" :chart-data="barChartTotal.chartData" :extra-options="barChartTotal.extraOptions"></bar-chart>
    </div>
</template>

<script>
import BarChart from '@/components/Charts/BarChart'
import { mapActions, mapGetters } from 'vuex'
import moment from 'moment';
import defaultChartObjects from "../defaultChartObjects"

export default {
    component: 'BarChartArrecadacao',

    components: {
        BarChart,
    },

    props: {
        height: {
            type: Number,
            default: 250
        },

        fetchProgress: {
            type: Number,
            default: 0 | 100
        },

        colors: {
            type: Array,
            default: []
        },

        defaultBarThickness: {
          type: Number,
          default: 8,
        },

        maxBarThickness: {
            type: Number,
            default: 30,
        },

        formattedPaidBillItems: {
            type: Array,
            default: []
        },

        hideWhilePrintingPDF: {
            type: Boolean,
            default: false | true
        },
    },

    data: () => {
        return {
        }
    },

    watch: {
        barChartTotal(newVal) {
            this.$emit("legendaChartArrecadacao", this.legendaChartArrecadacao)
        },
    },

    computed: {
        ...mapGetters('product', {
            useChartCache: "getUseChartCache",
            chartObject: "getBarChartArrecadacao",
        }),

        legendaChartArrecadacao() {
            var labels = this.barChartTotal.chartData.labels

            var datasets = this.barChartTotal.chartData.datasets.map(function (val, idx) {
                return { data: val.data, label: val.label }
            })

            return { labels: labels, datasets: datasets }
        },

        barChartTotal() {
            var defaultChart = {}
            defaultChart = JSON.parse(JSON.stringify(defaultChartObjects.defaultBarChartArrecadacao))

            if(this.useChartCache == true && this.chartObject.chartData != undefined){
              defaultChart = JSON.parse(JSON.stringify(this.chartObject))
              if(this.fetchProgress < 100){
                sessionStorage.removeItem('SET_BAR_CHART_ARRECADACAO_save')
              }
            }

            if(this.fetchProgress == 0 || this.fetchProgress == 100){
                let weekdayLabels = ['Dom', 'Seg', 'Ter', 'Qua', 'Qui', 'Sex', 'Sáb']
                var barColors = '#1d889c'
                var lineColors = ['#69D4E8','#002c3b']
                var labels = []    //LABELS OF CHART
                var amountLabel = 'Visitantes' //Label for charts amount
                var chartInfo = this.formattedPaidBillItems         //DATA OF CHART
                var dateIndexes = []
                // var deb = { 'online': 0, 'local': 0 }

                chartInfo.map(function (itemArrayTable) {
                    var dateParts = itemArrayTable.data.split("/");
                    var day = moment(dateParts[0])
                    day = day.format("YYYY-MM-DD")
                    // var count = itemArrayTable.people.tableText.count / 1
                    var valorOnline = 0
                    var valorLocal = 0
                    var valorTotal = 0
                    
                    // LOCAL PAYMENT
                    if (itemArrayTable.confirmPayment && itemArrayTable.confirmPayment.hasLocalPayment) {
                        if(itemArrayTable.paymentMethod !== 'pos_cortesia'){
                            valorLocal = itemArrayTable.finalValue
                            valorTotal = valorTotal + valorLocal
                        }
                    }

                    // ONLINE PAYMENT
                    else if(itemArrayTable.confirmPayment && itemArrayTable.confirmPayment.hasLocalPayment == false) {
                        valorOnline = itemArrayTable.finalValue
                        valorTotal = valorTotal + valorOnline
                    }

                    if (undefined == dateIndexes[day]) {
                      let label = moment(day)
                        label = label.format("DD/MM/YY") + ' (' + weekdayLabels[label.day()].toLowerCase() + ')'
                        dateIndexes[day] = { /*count: 0,*/ day: day, online: 0, local: 0, total: 0, label: label}
                        labels.push(day)
                    }
                    // dateIndexes[day]['count'] += count
                    dateIndexes[day]['online'] += valorOnline
                    dateIndexes[day]['local'] += valorLocal
                    dateIndexes[day]['total'] += valorTotal
                    // deb['online'] += valorOnline
                    // deb['local'] += valorLocal
                })

                labels.sort()

                let convertedLabels = labels.map((el) => { return dateIndexes[el].label })

                dateIndexes = Object.values(dateIndexes)
                // var itensCountInfoArray = new Array(labels.length).fill(0)
                var totalPaidInfoArray = new Array(labels.length).fill(0)
                var onlinePaidInfoArray = new Array(labels.length).fill(0)
                var localPaidInfoArray = new Array(labels.length).fill(0)

                //FILLING THE POSITION OF THE ARRAY ACCORDING TO DATE
                dateIndexes.map(function (val, idx) {
                    // itensCountInfoArray[labels.indexOf(val.day)] += val.count
                    totalPaidInfoArray[labels.indexOf(val.day)] += val.total
                    onlinePaidInfoArray[labels.indexOf(val.day)] += val.online
                    localPaidInfoArray[labels.indexOf(val.day)] += val.local
                })

                // chartInfo = itensCountInfoArray;

                defaultChart.chartData = {
                    labels: convertedLabels,      //NOMES DOS LABELS DO PERIODO
                    datasets: [
                        // {
                        //     label: `${amountLabel.toLocaleLowerCase()}`,
                        //     yAxisID: 'A',
                        //     data: chartInfo,               //VALOR DA QNTD DE VISITANTE POR PERIODO
                        //     backgroundColor: barColors,
                        //     barThickness: this.defaultBarThickness,
                        //     maxBarThickness: this.maxBarThickness,
                        // },
                        {
                            label: 'Total Pago',
                            yAxisID: 'B',
                            data: totalPaidInfoArray,
                            backgroundColor: barColors,
                            barThickness: this.defaultBarThickness,
                            maxBarThickness: this.maxBarThickness,
                        },
                        {
                            label: 'Pago Online',
                            yAxisID: 'B',
                            data: onlinePaidInfoArray.reduce((prev, curr) => prev + curr, 0) > 0 ? onlinePaidInfoArray : [],
                            backgroundColor: 'transparent',
                            borderColor: lineColors[0],
                            barThickness: this.defaultBarThickness,
                            maxBarThickness: this.maxBarThickness,
                            type: 'line',
                        },
                        {
                            label: 'Pago no Local',
                            yAxisID: 'B',
                            data: localPaidInfoArray.reduce((prev, curr) => prev + curr, 0) > 0 ? localPaidInfoArray : [],
                            backgroundColor: 'transparent',
                            borderColor: lineColors[1],
                            barThickness: this.defaultBarThickness,
                            maxBarThickness: this.maxBarThickness,
                            type: 'line',
                        }
                    ]
                }

                defaultChart.extraOptions = {
                    legend: {
                        display: true,
                        position: 'top'
                    },
                    animation: false,
                    transitions: {
                        ative: {
                            animation: {
                                duration: 0,
                            }
                        }
                    },
                    tooltips: {
                        callbacks: {
                            label: function (tooltipItem, yAxes) {
                                return ((tooltipItem.datasetIndex == 0 || tooltipItem.datasetIndex == 1 || tooltipItem.datasetIndex == 2)
                                    ? "R$ " + Number(tooltipItem.value).toFixed(2).replace('.', ',')
                                    : `${Number(tooltipItem.value)}`) + ' ' + yAxes.datasets[tooltipItem.datasetIndex]['label'];
                            },
                        },
                        opacity: 0.1,
                        yAlign: 'bottom',
                        xAlign: 'center',
                    },
                    scales: {
                        yAxes: [
                        // {
                        //     id: 'A',
                        //     type: 'linear',
                        //     position: 'left',
                        //     ticks: {
                        //         mirror: true,
                        //         autoSkip: true,
                        //         includeBounds: true,
                        //         display: false,
                        //         title: "Quantidade",
                        //     },
                        // },
                        {
                            id: 'B',
                            type: 'linear',
                            position: 'left',
                            ticks: {
                                callback: function (value, index, ticks) { return 'R$' + value; },
                                mirror: true,
                                autoSkip: true,
                                includeBounds: true,
                                display: true,
                                title: "Valor",
                            }
                        }],
                    },
                }

                if(this.useChartCache == true && this.fetchProgress == 100 && !sessionStorage.getItem('SET_BAR_CHART_ARRECADACAO_save')){
                  sessionStorage.setItem('SET_BAR_CHART_ARRECADACAO_save','1')
                  this.productStoreCommit({ mutation:"SET_BAR_CHART_ARRECADACAO", value: JSON.parse(JSON.stringify(defaultChart)) })
                }
            }
            return defaultChart
        },

    },

    methods: {
        ...mapActions('product',[
            "productStoreCommit",
        ]),

    },
}

</script>
